// import { isValid } from "react-datepicker/dist/dist/date_utils.js";
import { NONE } from "../constants/filter";
// import { error } from "ajv/dist/vocabularies/applicator/dependencies";

// constant variables
const getDurationFilters = () => {
  return [
    { key: "none", label: "None", value: "none" },
    { key: "weekly", label: "Weekly", value: "weekly" },
    { key: "monthly", label: "Monthly", value: "monthly" },
    { key: "yearly", label: "Yearly", value: "yearly" },
  ];
};

const getEntityFilters = () => {
  return [
    { key: "none", label: "None", value: "none" },
    { key: "courses", label: "Courses", value: "courses" },
    { key: "blogs", label: "Blogs", value: "blogs" },
  ];
};

const getStatsTypeFilters = () => {
  return [
    { key: "none", label: "None", value: "none" },
    {
      key: "mostAppreciated",
      label: "Most Appreciated",
      value: "mostAppreciatedEntity",
    },
    { key: "mostLiked", label: "Most Liked", value: "mostLikedEntity" },
    {
      key: "mostCommented",
      label: "Most Commented",
      value: "mostCommentedEntity",
    },
  ];
};

const getFilterGroups = () => {
  return [
    {
      key: "byDuration",
      label: "By Duration",
      options: getDurationFilters(),
      isValid: true,
      errorMessage: "",
    },
    {
      key: "byEntityType",
      label: "By Entity Type",
      options: getEntityFilters(),
      isValid: true,
      errorMessage: "",
    },
    {
      key: "byStatsType",
      label: "By Stats Type",
      options: getStatsTypeFilters(),
      isValid: true,
      errorMessage: "",
    },
  ];
};

// const getFilterGroups1 = () => {
//   return [
//     {
//       key: "byDuration",
//       label: "By Duration",
//       options: getDurationFilters(),
//     },
//     {
//       key: "byEntityType",
//       label: "By Entity Type",
//       options: getEntityFilters(),
//     },
//     {
//       key: "byStatsType",
//       label: "By Stats Type",
//       options: getStatsTypeFilters(),
//     },
//   ];
// };

const getNoFilters = () => {
  return {
    byDuration: {
      key: NONE,
      label: NONE,
      value: NONE,
    },
    byEntityType: {
      key: NONE,
      label: NONE,
      value: NONE,
    },
    byStatsType: {
      key: NONE,
      label: NONE,
      value: NONE,
    },
    byDate: {
      key: NONE,
      label: NONE,
      value: NONE,
    },
  };
};

const getKnowledgeCardFilters = () => {
  return [
    { key: "all", label: "All", value: "all" },
    { key: "admin field notes", label: "Admin Field Notes", value: "admin field notes" },
    { key: "developer field notes", label: "Developer Field Notes", value: "developer field notes" },
    { key: "salesforce fix notes", label: "Salesforce Fix Notes", value: "salesforce fix notes" },
    { key: "concept notes", label: "Concept Notes", value: "concept notes" },
  ];
};

const getOrdersFilters = () => {
  return [
    { key: "all", label: "All", value: "all" },
    { key: "pending", label: "Pending", value: "pending" },
    { key: "paid", label: "Paid", value: "paid" },
  ];
};

export { getFilterGroups, getNoFilters, getKnowledgeCardFilters, getOrdersFilters };
